// The issues an image without symbols leaves raw (a release's AFFECTS, Symbols' ISSUES): the first
// three as small mono links to each issue, then "+N", or a dash when none. The cell holding it
// takes the class `aff`, so a long id ends in an ellipsis with the whole id in its title.
import { Link } from '@tanstack/react-router'
import { useI18n } from '../i18n'
import { LK } from './d'

const SHOWN = 3

export function AffectedIssues({
  orgId,
  projectId,
  issues,
  count,
  appId,
}: {
  orgId: string
  projectId: string
  issues: readonly string[]
  /** Every issue it affects; `issues` may hold only the first few. */
  count: number
  /** The app the page is scoped to, kept on the issue's page. */
  appId?: string | undefined
}) {
  const { number } = useI18n()
  const shown = issues.slice(0, SHOWN)
  const more = count - shown.length
  if (count === 0) return <span className="faint">—</span>
  return (
    <>
      {shown.map((issue) => (
        <Link
          key={issue}
          className={LK}
          to="/o/$orgId/p/$projectId/issues/$issueId"
          params={{ orgId, projectId, issueId: issue }}
          search={appId ? { app: appId } : {}}
          translate="no"
          title={issue}
        >
          {issue}
        </Link>
      ))}
      {more > 0 ? <span className="faint">{`+${number(more)}`}</span> : null}
    </>
  )
}
